/* Lover's F.C — site behaviour. Nothing here is required for a page to work:
   every link is a real link, and the script only makes it smoother. */
(function () {

  /* ---------------------------------------------------------------------
     Images fade up from their placeholder once decoded. The box is already
     reserved by width/height, so this never affects layout.
     --------------------------------------------------------------------- */
  function mark(img) { img.setAttribute('data-loaded', ''); }

  function scan(root) {
    (root || document).querySelectorAll('.lv-frame > img:not([data-loaded])').forEach(function (img) {
      if (img.complete && img.naturalWidth) { mark(img); }
      else { img.addEventListener('load', function () { mark(img); }, { once: true }); }
    });
  }

  /* ---------------------------------------------------------------------
     Shop: continuous scroll, in-place filtering, and scroll restoration (§5, §9).
     Fetches go through the Section Rendering API. On any failure they fall
     back to ordinary navigation, so the worst case is a normal page load.
     --------------------------------------------------------------------- */
  function sectionUrl(url, id) {
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', id);
    return u.toString();
  }

  function fetchSection(url, id) {
    return fetch(sectionUrl(url, id), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var shop = doc.querySelector('[data-lovers-shop]');
        if (!shop) throw new Error('no shop in response');
        return shop;
      });
  }

  function armShop(root) {
    if (!root || root.hasAttribute('data-armed')) return;
    root.setAttribute('data-armed', '');
    var id = root.getAttribute('data-section');
    var busy = false;
    var io = null;

    function count() { return root.querySelectorAll('.lv-tile').length; }

    /* Resolves true once the next page of tiles is on the page. */
    function more(link) {
      if (busy) return Promise.resolve(false);
      busy = true;
      link.setAttribute('aria-busy', 'true');
      return fetchSection(link.href, id).then(function (next) {
        var wall = root.querySelector('[data-lovers-wall]');
        var incoming = next.querySelector('[data-lovers-wall]');
        while (incoming && incoming.firstElementChild) wall.appendChild(incoming.firstElementChild);
        var wrap = root.querySelector('[data-lovers-more]');
        var nextWrap = next.querySelector('[data-lovers-more]');
        if (nextWrap) wrap.replaceWith(nextWrap); else wrap.remove();
        scan(wall);
        busy = false;
        watch();
        return true;
      }).catch(function () { location.href = link.href; return false; });
    }

    function watch() {
      if (io) io.disconnect();
      var link = root.querySelector('[data-lovers-next]');
      if (!link || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); more(link); }
      }, { rootMargin: '900px 0px' });
      io.observe(link);
    }

    function filter(url, push) {
      root.setAttribute('aria-busy', 'true');
      fetchSection(url, id).then(function (next) {
        root.innerHTML = next.innerHTML;
        root.removeAttribute('aria-busy');
        if (push) history.pushState({ loversShop: true }, '', url);
        scan(root);
        watch();
      }).catch(function () { location.href = url; });
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      if (a.hasAttribute('data-lovers-next')) { e.preventDefault(); more(a); }
      else if (a.hasAttribute('data-lovers-filter')) {
        e.preventDefault();
        if (a.getAttribute('aria-current') !== 'page') filter(a.href, true);
      }
    });

    /* Mark the entry we arrived on, so Back from a filter restores it. */
    if (!history.state) history.replaceState({ loversShop: true }, '');
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.loversShop) filter(location.href, false);
    });

    /* Back from a product returns to the same place in the shop. The store
       sends no-store, so the page is usually rebuilt rather than restored from
       the back/forward cache, and tiles that were scrolled into existence are
       gone. Remember how many there were and where we were; on the way back,
       load up to that count first, then scroll. */
    var key = 'lv-shop:' + location.pathname + location.search;

    addEventListener('pagehide', function () {
      try { sessionStorage.setItem(key, JSON.stringify({ tiles: count(), y: scrollY })); } catch (e) {}
    });

    function restore() {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!nav || nav.type !== 'back_forward') return;
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
      if (!saved || saved.tiles <= count()) return;   /* nothing appended: the browser handles it */
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      (function step() {
        var link = root.querySelector('[data-lovers-next]');
        if (count() >= saved.tiles || !link) { scrollTo(0, saved.y); return; }
        more(link).then(function (ok) { if (ok) step(); });
      })();
    }

    watch();
    restore();
  }

  /* ---------------------------------------------------------------------
     Club panel tabs (§6: tabs swap in place, no reload). ARIA tabs pattern:
     arrow keys move between tabs, Home/End jump to the ends. Without JS the
     panels are simply stacked, so nothing is ever unreachable. The URL hash
     (#orders, #email) picks the tab, so links and form posts land correctly.
     --------------------------------------------------------------------- */
  function armTabs(list) {
    if (list.hasAttribute('data-armed')) return;
    list.setAttribute('data-armed', '');
    var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) tab.focus();
    }

    list.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) return;
      select(t);
      history.replaceState(history.state, '', '#' + t.getAttribute('data-tab'));
    });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement), n = null;
      if (i < 0) return;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') n = tabs[0];
      else if (e.key === 'End') n = tabs[tabs.length - 1];
      if (n) { e.preventDefault(); select(n, true); }
    });

    /* Shopify's customer form returns with ?customer_posted=true. */
    var want = location.hash.slice(1) ||
      (/customer_posted=/.test(location.search) ? 'email' : '');
    var start = tabs.filter(function (t) { return t.getAttribute('data-tab') === want; })[0] || tabs[0];
    select(start);
    list.setAttribute('data-ready', '');
  }

  /* ---------------------------------------------------------------------
     Club email switch. The switch moves the moment it is tapped (§5: respond
     inside 200ms), then Shopify's own customer form is submitted - the real
     write happens server-side, never here. requestSubmit() fires the form's
     submit event, so Shopify's bot protection still sees a normal submission.
     A locked switch (already subscribed, no backend yet) nudges and explains.
     --------------------------------------------------------------------- */
  function armSwitch(btn) {
    if (btn.hasAttribute('data-armed')) return;
    btn.setAttribute('data-armed', '');
    var form = btn.form;
    var status = form.querySelector('[data-lv-switch-status]');
    var note = form.querySelector('[data-lv-switch-note]');
    var sent = false;
    var busy = false;
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var club = btn.closest('[data-club-pass]');

    var SAY_ON = 'On.';
    var SAY_OFF = 'Off.';

    /* Live: both directions go to the backend, which checks the Club pass and
       makes the change server-side. The switch moves at once; if the backend
       says no, it moves back and says why. */
    function flip() {
      if (busy) return;
      busy = true;
      var want = btn.getAttribute('aria-checked') !== 'true';
      btn.classList.remove('lv-switch--just', 'lv-switch--nudge');
      void btn.offsetWidth;
      btn.setAttribute('aria-checked', want ? 'true' : 'false');
      if (want) btn.classList.add('lv-switch--just');
      if (note) note.hidden = true;
      if (status) status.textContent = want ? 'Adding you to the list.' : 'Taking you off the list.';

      fetch(club.getAttribute('data-club-api') + '/club/email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Club-Pass': club.getAttribute('data-club-pass') },
        body: JSON.stringify({ subscribed: want })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) throw new Error(j.error || 'That did not save. Please try again.');
            return j;
          });
        })
        .then(function (j) {
          btn.setAttribute('aria-checked', j.subscribed ? 'true' : 'false');
          if (!j.subscribed) btn.classList.remove('lv-switch--just');
          if (status) status.textContent = j.subscribed ? SAY_ON : SAY_OFF;
          /* Switching on earns the sign-up code: show it where codes live. */
          if (j.subscribed && j.wallet) refreshReward(true);
        })
        .catch(function (err) {
          btn.classList.remove('lv-switch--just');
          btn.setAttribute('aria-checked', want ? 'false' : 'true');
          /* A dropped connection surfaces as a TypeError; don't show its raw text. */
          var say = err && err.name !== 'TypeError' && err.message;
          if (status) status.textContent = say || 'That did not save. Please try again.';
        })
        .then(function () { busy = false; });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (club && btn.hasAttribute('data-live')) { flip(); return; }
      if (btn.hasAttribute('data-locked')) {
        if (note) note.hidden = false;
        btn.classList.remove('lv-switch--nudge');
        void btn.offsetWidth;               /* restart the animation */
        btn.classList.add('lv-switch--nudge');
        return;
      }
      if (sent) return;
      sent = true;
      btn.setAttribute('aria-checked', 'true');
      btn.classList.add('lv-switch--just');
      if (status) status.textContent = 'Adding you to the list.';
      setTimeout(function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }, still ? 0 : 420);
    });
  }

  /* ---------------------------------------------------------------------
     The hero fills the screen BELOW the header, not the whole screen: this
     theme's header is tall, so 100svh would push the drop's name and button
     out of sight. Measure it once, and again when the window changes.
     --------------------------------------------------------------------- */
  function headerHeight() {
    var h = document.querySelector('.section-header, .header-wrapper, #shopify-section-header');
    var px = h ? Math.round(h.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--lv-header', px + 'px');
  }

  /* ---------------------------------------------------------------------
     Members' ground: the reward code, the countdown.
     --------------------------------------------------------------------- */

  /* Copy is one tap and confirms visibly (§6). */
  function armCopy(btn) {
    if (btn.hasAttribute('data-armed')) return;
    btn.setAttribute('data-armed', '');
    btn.addEventListener('click', function () {
      var ticket = btn.closest('[data-lv-ticket]');
      var code = ticket.querySelector('[data-lv-code]').textContent.trim();
      var said = ticket.querySelector('[data-lv-copy-status]');
      function done() {
        btn.textContent = 'Copied';
        btn.classList.add('is-done');
        if (said) said.textContent = 'Code copied.';
        setTimeout(function () { btn.textContent = 'Copy'; btn.classList.remove('is-done'); }, 2200);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { selectCode(ticket); });
      } else { selectCode(ticket); }
    });
  }
  /* No clipboard access: select the code so a long-press copies it. */
  function selectCode(ticket) {
    var r = document.createRange();
    r.selectNodeContents(ticket.querySelector('[data-lv-code]'));
    var s = getSelection(); s.removeAllRanges(); s.addRange(r);
  }

  /* Re-read the reward block from the server, so the page shows exactly what
     Liquid would. Used after the backend issues or unlocks a code. */
  function refreshReward(printed) {
    var old = document.querySelector('[data-lv-reward]');
    if (!old) return;
    fetch(location.pathname, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lv-reward]');
        if (!fresh) return;
        old.replaceWith(fresh);
        /* Only codes that weren't on the page before print in. */
        var had = {};
        old.querySelectorAll('[data-lv-code]').forEach(function (c) { had[c.textContent.trim()] = 1; });
        if (printed) fresh.querySelectorAll('[data-lv-ticket]').forEach(function (t) {
          var c = t.querySelector('[data-lv-code]');
          if (c && !had[c.textContent.trim()]) t.classList.add('is-new');
        });
        fresh.querySelectorAll('[data-lv-copy]').forEach(armCopy);
      })
      .catch(function () {});
  }

  /* A member who has never had a code gets their first one on this visit. */
  function armReward(block) {
    if (block.hasAttribute('data-armed')) return;
    block.setAttribute('data-armed', '');
    var club = block.closest('[data-club-pass]');
    if (!club || block.getAttribute('data-state') !== 'unknown') return;
    fetch(club.getAttribute('data-club-api') + '/club/reward', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Club-Pass': club.getAttribute('data-club-pass') },
      body: '{}'
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { refreshReward(true); })
      .catch(function () {
        var what = block.querySelector('.lv-ticket__what');
        if (what) what.textContent = 'Your code will be here shortly. Try again in a minute.';
      });
  }

  /* Countdown to release day. Members can buy any time that day, so it runs
     to the START of the day (YYYY-MM-DD), in the visitor's own time. Updates
     once a second; the words for screen readers are static, so nothing is
     announced every tick. */
  function armCountdown(el) {
    if (el.hasAttribute('data-armed')) return;
    el.setAttribute('data-armed', '');
    var p = (el.getAttribute('data-lv-countdown-date') || '').split('-').map(Number);
    if (p.length !== 3 || !p[0]) return;
    var at = new Date(p[0], p[1] - 1, p[2]).getTime();
    var u = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, Math.floor((at - Date.now()) / 1000));
      u.d.textContent = pad(Math.floor(left / 86400));
      u.h.textContent = pad(Math.floor(left % 86400 / 3600));
      u.m.textContent = pad(Math.floor(left % 3600 / 60));
      u.s.textContent = pad(left % 60);
      if (!left) {
        clearInterval(timer);
        var when = el.parentNode.querySelector('[data-lv-drop-when]');
        if (when) when.textContent = 'Open to members now';
      }
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------------------------------------------------------------------
     Applications. The form posts to the backend, which takes the applicant's
     name and email from the signed-in customer rather than from the form.
     --------------------------------------------------------------------- */
  function appliedNote(when) {
    var d = document.createElement('div');
    d.className = 'lv-applied';
    var a = document.createElement('p');
    a.className = 'lv-applied__state';
    a.textContent = 'Applied ' + when;
    var b = document.createElement('p');
    b.className = 'lv-applied__note';
    b.textContent = 'We read every one. If it is a fit, we will email you.';
    d.appendChild(a); d.appendChild(b);
    return d;
  }

  function armApply(form) {
    if (form.hasAttribute('data-armed')) return;
    form.setAttribute('data-armed', '');
    var club = form.closest('[data-club-pass]');
    var say = form.querySelector('[data-lv-apply-status]');
    var button = form.querySelector('button[type="submit"]');
    var sending = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending || !club) return;
      sending = true;
      button.disabled = true;
      if (say) say.textContent = 'Sending.';

      var data = new FormData(form);
      fetch(club.getAttribute('data-club-api') + '/club/apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Club-Pass': club.getAttribute('data-club-pass') },
        body: JSON.stringify({
          kind: data.get('kind'),
          instagram: data.get('instagram'),
          links: data.get('links'),
          about: data.get('about')
        })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) throw new Error(j.error || 'That did not send. Please try again.');
            return j;
          });
        })
        .then(function () {
          var open = form.closest('[data-lv-apply]');
          if (open) open.replaceWith(appliedNote('just now'));
        })
        .catch(function (err) {
          sending = false;
          button.disabled = false;
          /* A dropped connection surfaces as a TypeError; don't show its raw text. */
          var msg = err && err.name !== 'TypeError' && err.message;
          if (say) say.textContent = msg || 'That did not send. Please try again.';
        });
    });
  }

  /* ---------------------------------------------------------------------
     A drop's photographs. The scrolling and snapping are the browser's; this
     adds the arrows, the counter and the arrow keys, and keeps them in step
     with wherever the strip has been swiped to.
     --------------------------------------------------------------------- */
  /* The number on the basket in the header, after something is added without
     the page reloading. The theme only draws the bubble when the basket has
     something in it, so the first thing added has to have one made for it. */
  function countCart() {
    if (!window.fetch) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.getElementById('cart-icon-bubble');
        if (!icon) return;

        var bubble = icon.querySelector('.cart-count-bubble');

        /* An empty basket has no bubble at all - the theme only draws one
           when there is something in it. Taking the last shirt back out has
           to leave the icon as it was found, not a badge reading nought. */
        if (!cart.item_count) {
          if (bubble) bubble.parentNode.removeChild(bubble);
          return;
        }

        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          icon.appendChild(bubble);
        }

        var seen = bubble.querySelector('[aria-hidden="true"]');
        var said = bubble.querySelector('.visually-hidden');
        if (seen) seen.textContent = cart.item_count < 100 ? cart.item_count : '';
        if (said) said.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';

        /* A small jump, so the eye is told where the shirt went. */
        icon.classList.remove('lv-bumped');
        void icon.offsetWidth;
        icon.classList.add('lv-bumped');
      })
      .catch(function () { /* the number is cosmetic; the basket is right */ });
  }

  /* The product page.

     The page works without any of this: sizes are radio inputs named "id",
     which is what the cart expects, so the form posts the chosen variant on
     its own. This only keeps the page honest once a size is picked - the
     price, whether it can be bought, and which photograph is showing. */
  function armPdp(root) {
    var store = root.querySelector('[data-lv-variants]');
    if (!store) return;

    var list = [];
    try { list = JSON.parse(store.textContent); } catch (e) { return; }

    var price = root.querySelector('[data-lv-price]');
    var was   = root.querySelector('[data-lv-was]');
    var add   = root.querySelector('[data-lv-add]');
    var stage = root.querySelector('[data-lv-stage]');
    var thumbs = root.querySelectorAll('[data-lv-thumb]');
    var buyLabel = add ? (add.getAttribute('data-lv-buy') || add.textContent.trim()) : '';
    var preLabel = add ? (add.getAttribute('data-lv-pre') || 'Pre-order') : '';

    /* Set further down, once the basket handling is wired up. Changing size
       has to clear the "In basket" state: the thing it would take back out
       is the size you were looking at a moment ago, not this one. */
    var forget = null;

    /* The gallery. The photographs are stacked and cross-faded rather than
       scrolled, which is what lets a swipe work cleanly on a phone: there is
       no scroll position to fight over. Same arrangement as the archive,
       without the part that moves on by itself - a gallery someone is
       reading should stay where they left it. */
    var slides = stage ? [].slice.call(stage.querySelectorAll('[data-lv-slide]')) : [];
    var tally = root.querySelector('[data-lv-count]');
    var at = 0;

    function show() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-on', i === at);
        s.setAttribute('aria-hidden', i === at ? 'false' : 'true');
      });
      Array.prototype.forEach.call(thumbs, function (b, i) {
        b.classList.toggle('is-on', i === at);
      });
      if (tally) tally.textContent = (at + 1) + ' / ' + slides.length;
    }

    /* Wraps both ways, so the last photograph leads back to the first. */
    function go(step) {
      if (slides.length < 2) return;
      at = (at + step + slides.length) % slides.length;
      show();
    }

    function jump(i) {
      if (i < 0 || i >= slides.length || i === at) return;
      at = i;
      show();
    }

    if (slides.length > 1) {
      if (tally) tally.hidden = false;
      stage.tabIndex = 0;

      Array.prototype.forEach.call(thumbs, function (btn) {
        btn.addEventListener('click', function () {
          jump(parseInt(btn.getAttribute('data-lv-thumb'), 10) || 0);
        });
      });

      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });

      /* Swipe. The stage is touch-action:pan-y, so the browser keeps vertical
         scrolling and leaves sideways movement to us - the swipe no longer
         has to beat the page to it. Intent is settled as soon as the finger
         has gone a little further across than down, and the pointer is
         captured so the rest of the gesture belongs to the gallery. */
      var fromX = 0, fromY = 0, tracking = false, sideways = false;

      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        tracking = true; sideways = false;
        fromX = e.clientX; fromY = e.clientY;
      });

      stage.addEventListener('pointermove', function (e) {
        if (!tracking || sideways) return;
        var dx = Math.abs(e.clientX - fromX), dy = Math.abs(e.clientY - fromY);
        if (dx > 8 && dx > dy) {
          sideways = true;
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        } else if (dy > 12) {
          tracking = false;   /* they are scrolling the page; leave them to it */
        }
      });

      stage.addEventListener('pointerup', function (e) {
        if (!tracking) return;
        var dx = e.clientX - fromX;
        tracking = false;
        if (sideways && Math.abs(dx) > 30) go(dx < 0 ? 1 : -1);
        sideways = false;
      });

      stage.addEventListener('pointercancel', function () {
        tracking = false; sideways = false;
      });
    }

    /* A size with its own photograph brings that photograph forward. */
    function showMedia(id) {
      if (!id) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-lv-media') === String(id)) { jump(i); return; }
      }
    }

    function pick(id) {
      var found = null, i;
      for (i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(id)) { found = list[i]; break; }
      }
      if (!found) return;

      if (price) price.textContent = found.price;
      if (was) {
        if (found.hasWas) { was.textContent = found.was; was.hidden = false; }
        else { was.hidden = true; }
      }
      if (add) {
        if (forget) forget();
        add.disabled = !found.ok;
        if (!found.ok) { add.textContent = 'Sold out'; }
        else { add.textContent = found.pre ? preLabel : buyLabel; }
      }
      showMedia(found.media);

      /* Keep the address bar on the chosen size, so a shared link opens on
         it. replaceState, not pushState: picking a size is not a page the
         back button should have to walk through. */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', found.id);
        history.replaceState({}, '', url);
      } catch (e) { /* older browser: the page still works */ }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') pick(e.target.value);
    });

    /* Adding to the basket without leaving the page.

       The form posts to /cart/add on its own if any of this fails, which is
       the point: someone with no JavaScript still gets their shirt, they
       just land on the basket page afterwards. */
    var form = root.querySelector('.lv-pdp__form');
    if (form && add && window.fetch && window.FormData) {
      var resting = add.getAttribute('data-lv-buy') || add.textContent.trim();
      var doneLabel = add.getAttribute('data-lv-done') || 'In basket';
      var settle;

      /* What the last press put in, so pressing again can take it out:
         which line of the basket, and how many of it we are answerable for.
         Someone who already had two of this size in the basket should get
         their two back, not an empty line. */
      var line = null, mine = 0, after = 0;

      function rest() {
        clearTimeout(settle);
        add.classList.remove('is-done', 'is-bad');
        add.removeAttribute('aria-pressed');
        add.removeAttribute('title');
        add.textContent = resting;
        add.disabled = false;
        line = null;
      }
      forget = rest;

      function wrong(label, hold) {
        add.classList.remove('is-done');
        add.classList.add('is-bad');
        add.textContent = label;
        settle = setTimeout(rest, hold);
      }

      function read(r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || '');
          return body;
        });
      }

      function put() {
        mine = parseInt(form.querySelector('[name="quantity"]') ?
          form.querySelector('[name="quantity"]').value : 1, 10) || 1;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
          .then(read)
          .then(function (added) {
            line = added.key;
            after = added.quantity;
            add.classList.remove('is-bad');
            add.classList.add('is-done');
            add.setAttribute('aria-pressed', 'true');
            add.setAttribute('title', 'Press again to take it back out');
            add.textContent = doneLabel;
            add.disabled = false;
            countCart();
          })
          .catch(function () {
            /* Say what went wrong rather than silently doing nothing. The
               usual cause is someone else taking the last one. */
            wrong('Could not add', 2600);
          });
      }

      function take() {
        var left = after - mine;
        if (left < 0) left = 0;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line, quantity: left })
        })
          .then(read)
          .then(function () {
            rest();
            countCart();
          })
          .catch(function () {
            wrong('Could not remove', 2600);
          });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (add.disabled) return;

        add.disabled = true;
        clearTimeout(settle);

        if (line) { take(); } else { put(); }
      });
    }

    /* "Size guide" beside the sizes opens the dropdown further down. */
    var link = root.querySelector('[data-lv-open-size]');
    var row  = root.querySelector('[data-lv-size-row]');
    if (link && row) {
      link.addEventListener('click', function () {
        row.open = true;
        var head = row.querySelector('summary');
        if (head) head.focus();
        row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  }

  /* A <details> that has to be open the moment the page loads: the contact
     form posts, the page comes back, and the answer would otherwise be shut
     inside a closed accordion. Used by the Write to us form in the Help
     list. */
  function armReveal(flag) {
    var box = flag.closest && flag.closest('details');
    if (!box) return;
    box.open = true;
    if (armReveal.done) return;
    armReveal.done = true;
    requestAnimationFrame(function () {
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  function armSlides(root) {
    if (root.hasAttribute('data-armed')) return;
    var stage = root.querySelector('[data-lv-slides-stage]');
    var bar = root.querySelector('[data-lv-slides-bar]');
    var slides = [].slice.call(root.querySelectorAll('[data-lv-slide]'));
    if (!bar || slides.length < 2) return;

    root.setAttribute('data-armed', '');
    var prev = bar.querySelector('[data-lv-slides-prev]');
    var next = bar.querySelector('[data-lv-slides-next]');
    var count = bar.querySelector('[data-lv-slides-count]');
    bar.hidden = false;
    stage.tabIndex = 0;

    var at = 0;
    var timer = null;
    /* It runs even for someone who asks for reduced motion: the CSS drops the
       fade for them, so the photographs change without anything animating.
       Stopping outright left the slideshow looking broken. The pause button
       is there either way. */
    var wanted = true;
    var every = (Number(root.getAttribute('data-lv-slides-every')) || 5) * 1000;
    /* Only a real pointer can hover. A tap fires pointerenter and never
       pointerleave, which stopped the slideshow for good on a phone. */
    var canHover = matchMedia('(hover:hover) and (pointer:fine)').matches;

    function show() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-on', i === at);
        /* Hidden slides are out of the tab order and out of the reading order. */
        s.setAttribute('aria-hidden', i === at ? 'false' : 'true');
      });
      count.textContent = (at + 1) + ' / ' + slides.length;
    }

    /* Wraps both ways: past the last is the first again. */
    function go(step) {
      at = (at + step + slides.length) % slides.length;
      show();
    }

    function tick() { go(1); }

    function start() {
      stop();
      if (!wanted) return;
      timer = setInterval(tick, every);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    prev.addEventListener('click', function () { go(-1); start(); });
    next.addEventListener('click', function () { go(1); start(); });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); start(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); start(); }
    });

    /* Hovering or tabbing in holds it still, so nothing moves while you look. */
    if (canHover) {
      root.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') stop(); });
      root.addEventListener('pointerleave', function () { if (wanted) start(); });
    }
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function () { if (wanted) start(); });

    /* Nothing should tick away in a tab nobody is looking at. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (wanted) start();
    });

    /* Swipe. The stage is touch-action:pan-y, so the browser keeps vertical
       scrolling and leaves sideways movement to us - a swipe no longer has to
       beat the page to it. Intent is decided as soon as the finger has moved
       a little further across than down, and the pointer is captured so the
       rest of the gesture belongs to the slideshow. */
    var startX = 0, startY = 0, tracking = false, sideways = false;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      tracking = true; sideways = false;
      startX = e.clientX; startY = e.clientY;
    });

    stage.addEventListener('pointermove', function (e) {
      if (!tracking || sideways) return;
      var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
      if (dx > 8 && dx > dy) {
        sideways = true;
        stop();
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      } else if (dy > 12) {
        tracking = false;   /* they are scrolling the page; leave them to it */
      }
    });

    function finish(e) {
      if (!tracking) return;
      var dx = e.clientX - startX;
      tracking = false;
      if (sideways && Math.abs(dx) > 30) go(dx < 0 ? 1 : -1);
      sideways = false;
      start();
    }
    stage.addEventListener('pointerup', finish);
    stage.addEventListener('pointercancel', function () { tracking = false; sideways = false; start(); });

    start();
    show();
  }

  function init(root) {
    headerHeight();
    scan(root);
    (root || document).querySelectorAll('[data-lv-slides]').forEach(armSlides);
    (root || document).querySelectorAll('[data-lv-copy]').forEach(armCopy);
    (root || document).querySelectorAll('[data-lv-reward]').forEach(armReward);
    (root || document).querySelectorAll('[data-lv-countdown-date]').forEach(armCountdown);
    (root || document).querySelectorAll('[data-lv-apply-form]').forEach(armApply);
    (root || document).querySelectorAll('[data-lv-reveal]').forEach(armReveal);
    (root || document).querySelectorAll('[data-lv-pdp]').forEach(armPdp);
    (root || document).querySelectorAll('[data-lovers-shop]').forEach(armShop);
    (root || document).querySelectorAll('[data-lv-tabs]').forEach(armTabs);
    (root || document).querySelectorAll('[data-lv-switch]').forEach(armSwitch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  var resizeTimer;
  addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(headerHeight, 150);
  });

  /* Sections re-render in the theme editor; catch those too. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
